import { doLogout, getTokenFromLocalStorage } from '../store/modules/player';
import { isElectronContext } from './isElectron';

let loggedOut = false;
export const listenBearer = () => {
  const prevToken = getTokenFromLocalStorage();

  setInterval(() => {
    const nextToken = getTokenFromLocalStorage();

    if (prevToken && !nextToken && !loggedOut && !isElectronContext()) {
      doLogout();
      loggedOut = true;
    }
  }, 1000);
};
